
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @generated SignedSource<<b387d58755674457ae4f39adf063ec37>>
 * @relayHash 4d36c161a002817ebf0a774bd870c3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e
const $52181a874b01b0e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentLookAndFeel",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScreenLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "background"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundColor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundImage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundPosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundSize"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundRepeat"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundOrigin"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundClip"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundAttachment"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundBlendMode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4d36c161a002817ebf0a774bd870c3f0",
            "id": "e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e",
            "metadata": {},
            "name": "MainLayoutQuery",
            "operationKind": "query",
            "text": "query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id,lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode}}}}}"
        }
    };
}();
$52181a874b01b0e6$var$node.hash = "de3e636b8d3cf59cd103bdc7552ea849";
var $52181a874b01b0e6$export$2e2bcd8739ae039 = $52181a874b01b0e6$var$node;



var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $5ZPtT = parcelRequire("5ZPtT");

/**
 * @generated SignedSource<<aee3d452e700222c207ed3413b38e9d4>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47
const $4a82a81af9c5e51c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b1c5bff520163b91e48e77e975abc312",
            "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
            "metadata": {},
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "operationKind": "query",
            "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
        }
    };
}();
$4a82a81af9c5e51c$var$node.hash = "5414d0003b526de29b97ae12c29148ab";
var $4a82a81af9c5e51c$export$2e2bcd8739ae039 = $4a82a81af9c5e51c$var$node;






var $55fM8 = parcelRequire("55fM8");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $1P7Cq = parcelRequire("1P7Cq");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");





var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $cozmU.useRef)(null);
    const allAppsLoaded = (0, $cozmU.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const presetTimeoutConfig = (0, $1xpoY.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $1xpoY.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $4a82a81af9c5e51c$export$2e2bcd8739ae039), {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "web-panel-location"
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel);
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");








var $gXfti = parcelRequire("gXfti");





















var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { extensions: extensions, isSSRResult: isSSRResult } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        hasPreloadedForgePageBanners: isSSRResult ? extensions.length > 0 : undefined,
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $cozmU.useRef)(null);
    const lastLoggedForgePageBannerHeightRef = (0, $cozmU.useRef)(undefined);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
            if (entry) {
                const height = entry.target.clientHeight;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.documentElement.style.setProperty('--forge-page-banner-height', `${height}px`);
                if (lastLoggedForgePageBannerHeightRef.current !== height) {
                    lastLoggedForgePageBannerHeightRef.current = height;
                    (0, $gXfti.addUFOCustomData)({
                        fixedForgePageBannerWrapperHeight: height
                    });
                }
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: height
                    }
                } : undefined;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};









var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $lzgC6 = parcelRequire("lzgC6");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $lzgC6.default)()(class ReturnToMobileComponent extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4FKVYE5zaO _2uo31fDMqu _2fwxA5DIqT"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: this.getSwitchToMobileHref(),
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", (event)=>{
            event.preventDefault();
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
        $796a872a5806d472$var$_defineProperty(this, "getSwitchToMobileHref", ()=>{
            const { getQueryParams: getQueryParams } = this.props;
            const queryParams = getQueryParams();
            const url = new URL(window.location.href);
            if (queryParams.desktop === 'true') url.searchParams.delete('desktop');
             // Resulting URL is same page, non-desktop override
            return url.toString();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $cozmU.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");








var $9wGTI = parcelRequire("9wGTI");


var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");








function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner);
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer);
    if (totalHeight) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");


var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    // Instrument the presence of non-content 3P background-script apps so their
    // keys are folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('background-script', forgeModules.map((app)=>app?.id));
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }));
const $b7830f7e8969acd1$var$PageBannerForgeAppWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
})(({ app: app, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attributes: {
            appId: (0, $8a9Dm.getAppId)(app)
        },
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.PageBannerForgeApp), {
        app: app,
        ...props
    }))); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    } // Instrument the presence of non-content 3P page-banner apps so their keys are
    // folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('page-banner', forgeModules.map((app)=>app?.id)); // A shared preset height is only safe for one Custom UI banner; UI Kit does not use an iframe.
    const shouldPresetHeight = forgeModules.length === 1 && forgeModules[0]?.properties?.resource != null && forgeModules[0]?.properties?.render !== 'native';
    const pageBannerProps = {
        shouldPresetHeight: shouldPresetHeight,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
            ...contentId ? {
                content: {
                    id: contentId,
                    type: (0, $hIaUw.getContentType)(routeName),
                    subtype: isLivePage ? 'live' : null
                }
            } : {},
            ...spaceKey || spaceAlias ? {
                space: {
                    id: spaceId,
                    key: spaceKey || spaceAlias
                }
            } : {}
        }
    };
    return forgeModules.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7830f7e8969acd1$var$PageBannerForgeAppWithErrorBoundary, {
            key: `${(0, $8a9Dm.getAppId)(app)}:${contentId ?? ''}`,
            app: app,
            ...pageBannerProps
        }));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
});


const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_3iDTPbvLZJ",
    hidePanel: "_3iDTPbYbGa"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fillContainerStyles = {
    container: "_3iDTPbQ4SZ _0aFT5vbt8w _3TGfC9LRg7 _0jFU0VN91d _4kiQYAdnbC",
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC"
};
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_23rrnH647S _0aFT5v1qpb _3TGfC9HnLE _39xV02N91d _2XsHFMPgdg _4eDzxwTTQh",
    addMinWidth: "_4ouGXIELL6"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_3iDTPbYbGa _42Yu6BaZ2J _39xV02N91d _1mT5xdy1CL _0KLXrulfZc _3OE6xY1nKm _1EqgXluI1V",
    showPanel: "_3iDTPbvLZJ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrulfZc _24h04i2Njc _1RrJLiBwqQ _4kiQYAIZbP _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS = [
    (0, $hrAmX.BannerStateContainer)
];
const $4e0d0b830c02a893$var$getForgePageBannerPresetHeight = ()=>{
    try {
        const config = JSON.parse((0, $1xpoY.default).getString('confluence_forge_banner_preset_height', ''));
        return typeof config.presetHeight === 'number' ? config.presetHeight : 0;
    } catch  {
        return 0;
    }
};
const $4e0d0b830c02a893$var$MainLayoutInnerContent = ({ fillContainer: fillContainer, enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children, isLivePage: isLivePage, ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport, renderServerPlaceholder: renderServerPlaceholder })=>{
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, shouldHideForgePageBanner: shouldHideForgePageBanner, hasPreloadedForgePageBanners: hasPreloadedForgePageBanners } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, true, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $cozmU.useState)(false);
    const shouldRenderATLGeneralWebPanel = shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport;
    const shouldOmitATLFooterWebPanel = isEdit || isLivePage || ommitComponentsNotNeededForPdfExport || renderServerPlaceholder;
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    const forgePageBannerInitialHeight = $4e0d0b830c02a893$var$getForgePageBannerPresetHeight();
    const shouldUseForgePageBannerInitialHeight = forgePageBannerInitialHeight > 5 && !(hasPreloadedForgePageBanners === false && (0, $6mKj3.expValEquals)('confluence_ssr_forge_page_banner', 'isEnabled', true));
    (0, $cozmU.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VjOtr"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": isForgePageBannerFixed ? 'fixed-forge-page-banner-wrapper-compiled' : 'forge-page-banner-wrapper-compiled',
        ref: fixedForgePageBannerRef,
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            isForgePageBannerFixed && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            isForgePageBannerFixed && !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isForgePageBannerFixed && $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            !isForgePageBannerFixed && shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), isForgePageBannerFixed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            "_0jFU0VNIFp"
        ])
    }));
    const renderContentBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _313842dnbC _24h04i2Njc _2uxTLTZSoF _1mT5xdRAKS _39xV02N91d _3iDTPbQ4SZ _4kiQYAZqHV",
                fillContainer && (0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars') && $4e0d0b830c02a893$var$fillContainerStyles.body
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle,
            className: (0, $hekY6.default)([
                fillContainer && (0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars') && $4e0d0b830c02a893$var$fillContainerStyles.body
            ])
        }, children));
    const mainLayoutContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            fillContainer && (0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars') && $4e0d0b830c02a893$var$fillContainerStyles.container,
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            "confluence-main-content"
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldRenderATLGeneralWebPanel && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $6mKj3.expValEquals)('confluence_banner_store_migration', 'isEnabled', true) ? renderContentBody() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS
    }, renderContentBody), !shouldOmitATLFooterWebPanel && (!fillContainer || !(0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER),
        // server rendered, invalidating the hydrated DOM. ATL_GENERAL passes `cache-first`
        // for the same reason.
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `.confluence-main-content .cp-container [role='dialog'] { z-index: 350; }`
        }
    }), mainLayoutContent) : null;
};
const $4e0d0b830c02a893$export$80006b81bf20e108 = (props)=>{
    const { isViewPage: isViewPage = false, isEdit: isEdit } = props;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const browserLocation = typeof globalThis.window?.location !== 'undefined' ? globalThis.window.location : undefined;
    const isPdfExport = browserLocation !== undefined && Boolean((0, $1NBp8.PDF_EXPORT_PAGE).match(browserLocation.pathname));
    const ommitComponentsNotNeededForPdfExport = isPdfExport;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    let webPanelBatchLocations = [];
    if (!ommitComponentsNotNeededForPdfExport) {
        if (isViewPage || isEdit) webPanelBatchLocations = [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ];
    }
    const shouldRenderWebPanelBatchProvider = webPanelBatchLocations.length > 0 && (0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$MainLayoutInnerContent, {
        ...props,
        isLivePage: isLivePage,
        ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport,
        renderServerPlaceholder: renderServerPlaceholder
    });
    return shouldRenderWebPanelBatchProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocationBatchProvider), {
        locations: webPanelBatchLocations
    }, content) : content;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $cozmU.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $cozmU.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZPtT.PageLayout), {
        editorPreloader: preloader,
        view: navView,
        fillContainer: props.fillContainer
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content);
};


const $a171d54840e7d827$var$MainLayoutQuery = (0, $52181a874b01b0e6$export$2e2bcd8739ae039);
const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $cozmU.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $jMyy4.useQueryInterop)($a171d54840e7d827$var$MainLayoutQuery, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage,
        __callerPackage__: "main-layout"
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("jFuBd"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("jFuBd", function(module, exports) {

let $e51995056e896b0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e51995056e896b0b$var$load("dZulV"),
    $e51995056e896b0b$var$load("gft53"),
    $e51995056e896b0b$var$load("fhJVC"),
    $e51995056e896b0b$var$load("DsM5z"),
    $e51995056e896b0b$var$load("lyagC"),
    $e51995056e896b0b$var$load("2jERw"),
    $e51995056e896b0b$var$load("b7144"),
    $e51995056e896b0b$var$load("jNr09"),
    $e51995056e896b0b$var$load("9xmQ5"),
    $e51995056e896b0b$var$load("g7Yjk"),
    $e51995056e896b0b$var$load("bSSct"),
    $e51995056e896b0b$var$load("iYvvi"),
    $e51995056e896b0b$var$load("eWXZF"),
    $e51995056e896b0b$var$load("g5INx"),
    $e51995056e896b0b$var$load("6wr18"),
    $e51995056e896b0b$var$load("2qF93"),
    $e51995056e896b0b$var$load("f4ASm"),
    $e51995056e896b0b$var$load("2EL9y"),
    $e51995056e896b0b$var$load("iEaDB"),
    $e51995056e896b0b$var$load("lHIG6"),
    $e51995056e896b0b$var$load("4a1y5"),
    $e51995056e896b0b$var$load("gpUln"),
    $e51995056e896b0b$var$load("aM1Vm"),
    $e51995056e896b0b$var$load("8eGGc"),
    $e51995056e896b0b$var$load("bWtlo"),
    $e51995056e896b0b$var$load("gWjIZ"),
    $e51995056e896b0b$var$load("VXbA1"),
    $e51995056e896b0b$var$load("ea3NB"),
    $e51995056e896b0b$var$load("3b8uf"),
    $e51995056e896b0b$var$load("XdB14"),
    $e51995056e896b0b$var$load("9TOep"),
    $e51995056e896b0b$var$load("7qcPK"),
    $e51995056e896b0b$var$load("dXWlR"),
    $e51995056e896b0b$var$load("11yNG"),
    $e51995056e896b0b$var$load("gQYVn"),
    $e51995056e896b0b$var$load("cpTbC"),
    $e51995056e896b0b$var$load("fhT77"),
    $e51995056e896b0b$var$load("jvUhP"),
    $e51995056e896b0b$var$load("7sOKp"),
    $e51995056e896b0b$var$load("7Ysw6"),
    $e51995056e896b0b$var$load("3xL2F"),
    $e51995056e896b0b$var$load("kMyku"),
    $e51995056e896b0b$var$load("hG1ar"),
    $e51995056e896b0b$var$load("ep2Eq"),
    $e51995056e896b0b$var$load("ffEVr"),
    $e51995056e896b0b$var$load("9BBvG"),
    $e51995056e896b0b$var$load("7J1PC"),
    $e51995056e896b0b$var$load("446Ip"),
    $e51995056e896b0b$var$load("cYv6T"),
    $e51995056e896b0b$var$load("el1U6"),
    $e51995056e896b0b$var$load("2yyll"),
    $e51995056e896b0b$var$load("azMlS"),
    $e51995056e896b0b$var$load("esYbQ"),
    $e51995056e896b0b$var$load("45r7q"),
    $e51995056e896b0b$var$load("hhss7"),
    $e51995056e896b0b$var$load("aAWLw"),
    $e51995056e896b0b$var$load("7EorR"),
    $e51995056e896b0b$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

/**
 * Discovery is filtered by space/page, visibility and context mode, so SSR data
 * (including an empty list) is reusable only for an equivalent request. Space-only
 * requests intentionally ignore contentId. Callers check module eligibility,
 * errors and snapshot lifetime separately.
 */ const $8eb9026be26e0c85$var$matchesExtensionListContext = (preloadedContext, currentContext)=>preloadedContext !== undefined && preloadedContext.spaceKey === currentContext.spaceKey && preloadedContext.includeHidden === currentContext.includeHidden && preloadedContext.spaceContextOnly === currentContext.spaceContextOnly && (currentContext.spaceContextOnly || preloadedContext.contentId === currentContext.contentId);
const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    let t6;
    if ($[4] !== isTransition || $[5] !== moduleType || $[6] !== resolvedAttachmentId || $[7] !== skipQuery || $[8] !== ssrExtensionResult) {
        t6 = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition && (0, $6mKj3.expValEquals)("confluence_ssr_forge_page_banner", "isEnabled", true) ? ssrExtensionResult : undefined;
        $[4] = isTransition;
        $[5] = moduleType;
        $[6] = resolvedAttachmentId;
        $[7] = skipQuery;
        $[8] = ssrExtensionResult;
        $[9] = t6;
    } else t6 = $[9];
    const pageBannerSSRResult = t6;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const t7 = skipQuery || preloadedPageBanners !== undefined;
    let t8;
    if ($[10] !== cloudId || $[11] !== contentId || $[12] !== locale || $[13] !== moduleType || $[14] !== queryOptions || $[15] !== resolvedAttachmentId || $[16] !== returnBlockedExtensions || $[17] !== spaceContextOnly || $[18] !== spaceKey || $[19] !== t7) {
        t8 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: t7
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[10] = cloudId;
        $[11] = contentId;
        $[12] = locale;
        $[13] = moduleType;
        $[14] = queryOptions;
        $[15] = resolvedAttachmentId;
        $[16] = returnBlockedExtensions;
        $[17] = spaceContextOnly;
        $[18] = spaceKey;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    const options = t8;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t10;
    let t9;
    if ($[21] !== extsError || $[22] !== spaceError) {
        t9 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t10 = [
            extsError,
            spaceError
        ];
        $[21] = extsError;
        $[22] = spaceError;
        $[23] = t10;
        $[24] = t9;
    } else {
        t10 = $[23];
        t9 = $[24];
    }
    (0, $cozmU.useEffect)(t9, t10);
    if (preloadedPageBanners) {
        let t11;
        if ($[25] !== preloadedPageBanners.extensions) {
            t11 = {
                extensions: preloadedPageBanners.extensions,
                loading: false,
                error: undefined,
                isSSRResult: true
            };
            $[25] = preloadedPageBanners.extensions;
            $[26] = t11;
        } else t11 = $[26];
        return t11;
    }
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
        let t11;
        if ($[27] !== ssrExtensionResult.error || $[28] !== ssrExtensionResult.extensions) {
            t11 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[27] = ssrExtensionResult.error;
            $[28] = ssrExtensionResult.extensions;
            $[29] = t11;
        } else t11 = $[29];
        return t11;
    }
    let t11;
    if ($[30] !== extsData || $[31] !== extsError || $[32] !== extsLoading) {
        t11 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[30] = extsData;
        $[31] = extsError;
        $[32] = extsLoading;
        $[33] = t11;
    } else t11 = $[33];
    return t11;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    // The boot payload belongs to the initial route. Never reuse it after navigation,
    // including when the user returns to the page that originally produced it.
    // Evaluate eligibility before inspecting the payload so control loads are exposed too.
    const pageBannerSSRResult = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition && (0, $6mKj3.expValEquals)('confluence_ssr_forge_page_banner', 'isEnabled', true) ? ssrExtensionResult : undefined;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery || preloadedPageBanners !== undefined
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        preloadedPageBanners,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (preloadedPageBanners) return {
        extensions: preloadedPageBanners.extensions,
        loading: false,
        error: undefined,
        isSSRResult: true
    };
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $89u2G = parcelRequire("89u2G");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(23);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2, skip: t3 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    const skip = t3 === undefined ? false : t3;
    const sharedDetail = (0, $cozmU.useContext)((0, $89u2G.SpaceDetailContext));
    const canUseSharedDetail = Boolean(spaceKey) && sharedDetail?.spaceKey === spaceKey && (!includeSpaceTypeSettings || sharedDetail?.space?.spaceTypeSettings !== undefined);
    let t4;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t4 = {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== canUseSharedDetail || $[6] !== skip) {
        t5 = skip || canUseSharedDetail ? {
            skip: true
        } : {};
        $[5] = canUseSharedDetail;
        $[6] = skip;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            variables: t4,
            ...t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const options = t6;
    const legacyResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    if (skip) {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                loading: false
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    let t7;
    if ($[12] !== canUseSharedDetail || $[13] !== legacyResult || $[14] !== sharedDetail) {
        t7 = canUseSharedDetail && sharedDetail ? {
            loading: sharedDetail.loading,
            data: sharedDetail.space ? {
                space: sharedDetail.space
            } : undefined,
            error: undefined
        } : legacyResult;
        $[12] = canUseSharedDetail;
        $[13] = legacyResult;
        $[14] = sharedDetail;
        $[15] = t7;
    } else t7 = $[15];
    const { loading: loading, data: data, error: error } = t7;
    let t8;
    if ($[16] !== data || $[17] !== includeSpaceTypeSettings) {
        t8 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[16] = data;
        $[17] = includeSpaceTypeSettings;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== error || $[20] !== loading || $[21] !== t8) {
        t9 = {
            loading: loading,
            data: t8,
            error: error
        };
        $[19] = error;
        $[20] = loading;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("89u2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $452d11e5a10e2733$export$4ae6180efef498fb = (0, $cozmU.createContext)(undefined);
module.exports["SpaceDetailContext"] = $452d11e5a10e2733$export$4ae6180efef498fb;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("6yagU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3Ap09 = parcelRequire("3Ap09");


var $dAzRS = parcelRequire("dAzRS");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null;
} : ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children } = t0;
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    let t1;
    if ($[0] !== closeAllPanels) {
        t1 = ()=>{
            closeAllPanels();
        };
        $[0] = closeAllPanels;
        $[1] = t1;
    } else t1 = $[1];
    const onPreviewPanelOpen = t1;
    let t2;
    if ($[2] !== closeOnlyPreviewPanel) {
        t2 = ()=>{
            closeOnlyPreviewPanel();
        };
        $[2] = closeOnlyPreviewPanel;
        $[3] = t2;
    } else t2 = $[3];
    const onPreviewPanelClose = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== onPreviewPanelClose || $[7] !== onPreviewPanelOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose,
            parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
        }, t3, children);
        $[5] = children;
        $[6] = onPreviewPanelClose;
        $[7] = onPreviewPanelOpen;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $cozmU.useCallback)(()=>{
        /*
    Any time a Preview Panel is opened in Confluence, we want to close all
    non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
    */ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $cozmU.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
    	Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
    	next panel are different, we want to close the previous panel before opening the new one. In order to
    	do this we need to pass the preview panel api
    */ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    let t0;
    let t1;
    if ($[0] !== closeOnlyPreviewPanel || $[1] !== location) {
        t0 = ()=>{
            const currentLocationKey = `${location.pathname}${location.search}`;
            const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
            if (currentLocationKey !== previousLocationKey) {
                closeOnlyPreviewPanel();
                previousLocation.current = location;
            }
        };
        t1 = [
            location,
            closeOnlyPreviewPanel
        ];
        $[0] = closeOnlyPreviewPanel;
        $[1] = location;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    (0, $cozmU.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $lRhY3 = parcelRequire("lRhY3");


var $3Ap09 = parcelRequire("3Ap09");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] !== hideObjectSidebar) {
        t0 = ()=>{
            window.dispatchEvent(new Event("closeGlobalSidebar"));
            hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const closeObjectSidebar = t0;
    let t1;
    if ($[2] !== close || $[3] !== context?.state?.panel) {
        t1 = (onClose)=>{
            if (context?.state?.panel) close(onClose);
        };
        $[2] = close;
        $[3] = context?.state?.panel;
        $[4] = t1;
    } else t1 = $[4];
    const closeOnlyPreviewPanel = t1;
    let t2;
    if ($[5] !== closeAll || $[6] !== closeObjectSidebar) {
        t2 = ()=>{
            closeAll();
            closeObjectSidebar();
        };
        $[5] = closeAll;
        $[6] = closeObjectSidebar;
        $[7] = t2;
    } else t2 = $[7];
    const closeAllPanels = t2;
    let t3;
    if ($[8] !== closeAllPanels || $[9] !== closeOnlyPreviewPanel) {
        t3 = {
            closeAllPanels: closeAllPanels,
            closeOnlyPreviewPanel: closeOnlyPreviewPanel
        };
        $[8] = closeAllPanels;
        $[9] = closeOnlyPreviewPanel;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Sidebar close is intentionally fire-and-forget
        hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, timeout: timeout, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            timeout: timeout,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("2GUjr"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5mAmG"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("2UfhE"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("4PfHU"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("4tw6h"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("fObhU"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("f9qit"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("dFwI0"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("dwPbT"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("lKE59"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fArXz"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("dMpk7"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("aMx68"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("2GUjr", function(module, exports) {

let $1f5b2f8ac5dde53f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f5b2f8ac5dde53f$var$load("7I4uK"),
    $1f5b2f8ac5dde53f$var$load("hUbK8"),
    $1f5b2f8ac5dde53f$var$load("LWh5V"),
    $1f5b2f8ac5dde53f$var$load("eRlPy"),
    $1f5b2f8ac5dde53f$var$load("30b92"),
    $1f5b2f8ac5dde53f$var$load("b6eef"),
    $1f5b2f8ac5dde53f$var$load("1Gr4q"),
    $1f5b2f8ac5dde53f$var$load("f7eY1"),
    $1f5b2f8ac5dde53f$var$load("kedWY"),
    $1f5b2f8ac5dde53f$var$load("9cVML"),
    $1f5b2f8ac5dde53f$var$load("7G12e"),
    $1f5b2f8ac5dde53f$var$load("4938u"),
    $1f5b2f8ac5dde53f$var$load("giX30"),
    $1f5b2f8ac5dde53f$var$load("lUYNi"),
    $1f5b2f8ac5dde53f$var$load("7SteV"),
    $1f5b2f8ac5dde53f$var$load("iYvvi"),
    $1f5b2f8ac5dde53f$var$load("eWXZF"),
    $1f5b2f8ac5dde53f$var$load("ennNB"),
    $1f5b2f8ac5dde53f$var$load("9Hr92"),
    $1f5b2f8ac5dde53f$var$load("khIi2"),
    $1f5b2f8ac5dde53f$var$load("eEjUf"),
    $1f5b2f8ac5dde53f$var$load("kMVpD"),
    $1f5b2f8ac5dde53f$var$load("7oAXW"),
    $1f5b2f8ac5dde53f$var$load("le1z7"),
    $1f5b2f8ac5dde53f$var$load("4xsdA"),
    $1f5b2f8ac5dde53f$var$load("kHXvF"),
    $1f5b2f8ac5dde53f$var$load("ea3NB"),
    $1f5b2f8ac5dde53f$var$load("59hV4"),
    $1f5b2f8ac5dde53f$var$load("cGkFm"),
    $1f5b2f8ac5dde53f$var$load("2jERw"),
    $1f5b2f8ac5dde53f$var$load("b7144"),
    $1f5b2f8ac5dde53f$var$load("fuOfV"),
    $1f5b2f8ac5dde53f$var$load("jL1Ke"),
    $1f5b2f8ac5dde53f$var$load("5MQ0D"),
    $1f5b2f8ac5dde53f$var$load("cvcNg"),
    $1f5b2f8ac5dde53f$var$load("iZR3N"),
    $1f5b2f8ac5dde53f$var$load("jXM1T"),
    $1f5b2f8ac5dde53f$var$load("6wr18"),
    $1f5b2f8ac5dde53f$var$load("4N1MY"),
    $1f5b2f8ac5dde53f$var$load("3LYaV"),
    $1f5b2f8ac5dde53f$var$load("ffEVr"),
    $1f5b2f8ac5dde53f$var$load("jNr09"),
    $1f5b2f8ac5dde53f$var$load("9xmQ5"),
    $1f5b2f8ac5dde53f$var$load("20wSi"),
    $1f5b2f8ac5dde53f$var$load("9LDVS"),
    $1f5b2f8ac5dde53f$var$load("kiMHu"),
    $1f5b2f8ac5dde53f$var$load("7J1PC"),
    $1f5b2f8ac5dde53f$var$load("446Ip"),
    $1f5b2f8ac5dde53f$var$load("fwbNS"),
    $1f5b2f8ac5dde53f$var$load("g7Yjk"),
    $1f5b2f8ac5dde53f$var$load("h4Nf7"),
    $1f5b2f8ac5dde53f$var$load("9TOep"),
    $1f5b2f8ac5dde53f$var$load("bSSct"),
    $1f5b2f8ac5dde53f$var$load("45r7q"),
    $1f5b2f8ac5dde53f$var$load("hhss7"),
    $1f5b2f8ac5dde53f$var$load("a8R25"),
    $1f5b2f8ac5dde53f$var$load("lnKog"),
    $1f5b2f8ac5dde53f$var$load("aAWLw"),
    $1f5b2f8ac5dde53f$var$load("7EorR"),
    $1f5b2f8ac5dde53f$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("5mAmG", function(module, exports) {

let $3e7b371a8e61d11b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3e7b371a8e61d11b$var$load("7I4uK"),
    $3e7b371a8e61d11b$var$load("hUbK8"),
    $3e7b371a8e61d11b$var$load("LWh5V"),
    $3e7b371a8e61d11b$var$load("eRlPy"),
    $3e7b371a8e61d11b$var$load("30b92"),
    $3e7b371a8e61d11b$var$load("b6eef"),
    $3e7b371a8e61d11b$var$load("1Gr4q"),
    $3e7b371a8e61d11b$var$load("f7eY1"),
    $3e7b371a8e61d11b$var$load("kedWY"),
    $3e7b371a8e61d11b$var$load("9cVML"),
    $3e7b371a8e61d11b$var$load("7G12e"),
    $3e7b371a8e61d11b$var$load("4938u"),
    $3e7b371a8e61d11b$var$load("giX30"),
    $3e7b371a8e61d11b$var$load("lUYNi"),
    $3e7b371a8e61d11b$var$load("7SteV"),
    $3e7b371a8e61d11b$var$load("iYvvi"),
    $3e7b371a8e61d11b$var$load("eWXZF"),
    $3e7b371a8e61d11b$var$load("ennNB"),
    $3e7b371a8e61d11b$var$load("9Hr92"),
    $3e7b371a8e61d11b$var$load("khIi2"),
    $3e7b371a8e61d11b$var$load("eEjUf"),
    $3e7b371a8e61d11b$var$load("kMVpD"),
    $3e7b371a8e61d11b$var$load("7oAXW"),
    $3e7b371a8e61d11b$var$load("le1z7"),
    $3e7b371a8e61d11b$var$load("4xsdA"),
    $3e7b371a8e61d11b$var$load("kHXvF"),
    $3e7b371a8e61d11b$var$load("ea3NB"),
    $3e7b371a8e61d11b$var$load("59hV4"),
    $3e7b371a8e61d11b$var$load("cGkFm"),
    $3e7b371a8e61d11b$var$load("2jERw"),
    $3e7b371a8e61d11b$var$load("b7144"),
    $3e7b371a8e61d11b$var$load("fuOfV"),
    $3e7b371a8e61d11b$var$load("jL1Ke"),
    $3e7b371a8e61d11b$var$load("5MQ0D"),
    $3e7b371a8e61d11b$var$load("cvcNg"),
    $3e7b371a8e61d11b$var$load("iZR3N"),
    $3e7b371a8e61d11b$var$load("jXM1T"),
    $3e7b371a8e61d11b$var$load("6wr18"),
    $3e7b371a8e61d11b$var$load("4N1MY"),
    $3e7b371a8e61d11b$var$load("3LYaV"),
    $3e7b371a8e61d11b$var$load("ffEVr"),
    $3e7b371a8e61d11b$var$load("jNr09"),
    $3e7b371a8e61d11b$var$load("9xmQ5"),
    $3e7b371a8e61d11b$var$load("20wSi"),
    $3e7b371a8e61d11b$var$load("9LDVS"),
    $3e7b371a8e61d11b$var$load("kiMHu"),
    $3e7b371a8e61d11b$var$load("7J1PC"),
    $3e7b371a8e61d11b$var$load("446Ip"),
    $3e7b371a8e61d11b$var$load("fwbNS"),
    $3e7b371a8e61d11b$var$load("g7Yjk"),
    $3e7b371a8e61d11b$var$load("h4Nf7"),
    $3e7b371a8e61d11b$var$load("9TOep"),
    $3e7b371a8e61d11b$var$load("bSSct"),
    $3e7b371a8e61d11b$var$load("45r7q"),
    $3e7b371a8e61d11b$var$load("hhss7"),
    $3e7b371a8e61d11b$var$load("a8R25"),
    $3e7b371a8e61d11b$var$load("lnKog"),
    $3e7b371a8e61d11b$var$load("aAWLw"),
    $3e7b371a8e61d11b$var$load("7EorR"),
    $3e7b371a8e61d11b$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("2UfhE", function(module, exports) {

let $21dcaac7b2c97acc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21dcaac7b2c97acc$var$load("7I4uK"),
    $21dcaac7b2c97acc$var$load("hUbK8"),
    $21dcaac7b2c97acc$var$load("LWh5V"),
    $21dcaac7b2c97acc$var$load("eRlPy"),
    $21dcaac7b2c97acc$var$load("30b92"),
    $21dcaac7b2c97acc$var$load("b6eef"),
    $21dcaac7b2c97acc$var$load("1Gr4q"),
    $21dcaac7b2c97acc$var$load("f7eY1"),
    $21dcaac7b2c97acc$var$load("kedWY"),
    $21dcaac7b2c97acc$var$load("9cVML"),
    $21dcaac7b2c97acc$var$load("7G12e"),
    $21dcaac7b2c97acc$var$load("4938u"),
    $21dcaac7b2c97acc$var$load("giX30"),
    $21dcaac7b2c97acc$var$load("lUYNi"),
    $21dcaac7b2c97acc$var$load("7SteV"),
    $21dcaac7b2c97acc$var$load("iYvvi"),
    $21dcaac7b2c97acc$var$load("eWXZF"),
    $21dcaac7b2c97acc$var$load("ennNB"),
    $21dcaac7b2c97acc$var$load("9Hr92"),
    $21dcaac7b2c97acc$var$load("khIi2"),
    $21dcaac7b2c97acc$var$load("eEjUf"),
    $21dcaac7b2c97acc$var$load("kMVpD"),
    $21dcaac7b2c97acc$var$load("7oAXW"),
    $21dcaac7b2c97acc$var$load("le1z7"),
    $21dcaac7b2c97acc$var$load("4xsdA"),
    $21dcaac7b2c97acc$var$load("kHXvF"),
    $21dcaac7b2c97acc$var$load("ea3NB"),
    $21dcaac7b2c97acc$var$load("59hV4"),
    $21dcaac7b2c97acc$var$load("cGkFm"),
    $21dcaac7b2c97acc$var$load("2jERw"),
    $21dcaac7b2c97acc$var$load("b7144"),
    $21dcaac7b2c97acc$var$load("fuOfV"),
    $21dcaac7b2c97acc$var$load("jL1Ke"),
    $21dcaac7b2c97acc$var$load("5MQ0D"),
    $21dcaac7b2c97acc$var$load("cvcNg"),
    $21dcaac7b2c97acc$var$load("iZR3N"),
    $21dcaac7b2c97acc$var$load("jXM1T"),
    $21dcaac7b2c97acc$var$load("6wr18"),
    $21dcaac7b2c97acc$var$load("4N1MY"),
    $21dcaac7b2c97acc$var$load("3LYaV"),
    $21dcaac7b2c97acc$var$load("ffEVr"),
    $21dcaac7b2c97acc$var$load("jNr09"),
    $21dcaac7b2c97acc$var$load("9xmQ5"),
    $21dcaac7b2c97acc$var$load("20wSi"),
    $21dcaac7b2c97acc$var$load("9LDVS"),
    $21dcaac7b2c97acc$var$load("kiMHu"),
    $21dcaac7b2c97acc$var$load("7J1PC"),
    $21dcaac7b2c97acc$var$load("446Ip"),
    $21dcaac7b2c97acc$var$load("fwbNS"),
    $21dcaac7b2c97acc$var$load("g7Yjk"),
    $21dcaac7b2c97acc$var$load("h4Nf7"),
    $21dcaac7b2c97acc$var$load("9TOep"),
    $21dcaac7b2c97acc$var$load("bSSct"),
    $21dcaac7b2c97acc$var$load("45r7q"),
    $21dcaac7b2c97acc$var$load("hhss7"),
    $21dcaac7b2c97acc$var$load("a8R25"),
    $21dcaac7b2c97acc$var$load("lnKog"),
    $21dcaac7b2c97acc$var$load("aAWLw"),
    $21dcaac7b2c97acc$var$load("7EorR"),
    $21dcaac7b2c97acc$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("4PfHU", function(module, exports) {

let $38381bfeb78e6be2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $38381bfeb78e6be2$var$load("7I4uK"),
    $38381bfeb78e6be2$var$load("hUbK8"),
    $38381bfeb78e6be2$var$load("LWh5V"),
    $38381bfeb78e6be2$var$load("eRlPy"),
    $38381bfeb78e6be2$var$load("30b92"),
    $38381bfeb78e6be2$var$load("b6eef"),
    $38381bfeb78e6be2$var$load("1Gr4q"),
    $38381bfeb78e6be2$var$load("f7eY1"),
    $38381bfeb78e6be2$var$load("kedWY"),
    $38381bfeb78e6be2$var$load("9cVML"),
    $38381bfeb78e6be2$var$load("7G12e"),
    $38381bfeb78e6be2$var$load("4938u"),
    $38381bfeb78e6be2$var$load("giX30"),
    $38381bfeb78e6be2$var$load("lUYNi"),
    $38381bfeb78e6be2$var$load("7SteV"),
    $38381bfeb78e6be2$var$load("iYvvi"),
    $38381bfeb78e6be2$var$load("eWXZF"),
    $38381bfeb78e6be2$var$load("ennNB"),
    $38381bfeb78e6be2$var$load("9Hr92"),
    $38381bfeb78e6be2$var$load("khIi2"),
    $38381bfeb78e6be2$var$load("eEjUf"),
    $38381bfeb78e6be2$var$load("kMVpD"),
    $38381bfeb78e6be2$var$load("7oAXW"),
    $38381bfeb78e6be2$var$load("le1z7"),
    $38381bfeb78e6be2$var$load("4xsdA"),
    $38381bfeb78e6be2$var$load("kHXvF"),
    $38381bfeb78e6be2$var$load("ea3NB"),
    $38381bfeb78e6be2$var$load("59hV4"),
    $38381bfeb78e6be2$var$load("cGkFm"),
    $38381bfeb78e6be2$var$load("2jERw"),
    $38381bfeb78e6be2$var$load("b7144"),
    $38381bfeb78e6be2$var$load("fuOfV"),
    $38381bfeb78e6be2$var$load("jL1Ke"),
    $38381bfeb78e6be2$var$load("5MQ0D"),
    $38381bfeb78e6be2$var$load("cvcNg"),
    $38381bfeb78e6be2$var$load("iZR3N"),
    $38381bfeb78e6be2$var$load("jXM1T"),
    $38381bfeb78e6be2$var$load("6wr18"),
    $38381bfeb78e6be2$var$load("4N1MY"),
    $38381bfeb78e6be2$var$load("3LYaV"),
    $38381bfeb78e6be2$var$load("ffEVr"),
    $38381bfeb78e6be2$var$load("jNr09"),
    $38381bfeb78e6be2$var$load("9xmQ5"),
    $38381bfeb78e6be2$var$load("20wSi"),
    $38381bfeb78e6be2$var$load("9LDVS"),
    $38381bfeb78e6be2$var$load("kiMHu"),
    $38381bfeb78e6be2$var$load("7J1PC"),
    $38381bfeb78e6be2$var$load("446Ip"),
    $38381bfeb78e6be2$var$load("fwbNS"),
    $38381bfeb78e6be2$var$load("g7Yjk"),
    $38381bfeb78e6be2$var$load("h4Nf7"),
    $38381bfeb78e6be2$var$load("9TOep"),
    $38381bfeb78e6be2$var$load("bSSct"),
    $38381bfeb78e6be2$var$load("45r7q"),
    $38381bfeb78e6be2$var$load("hhss7"),
    $38381bfeb78e6be2$var$load("a8R25"),
    $38381bfeb78e6be2$var$load("lnKog"),
    $38381bfeb78e6be2$var$load("aAWLw"),
    $38381bfeb78e6be2$var$load("7EorR"),
    $38381bfeb78e6be2$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("4tw6h", function(module, exports) {

let $3422c550dfbb616d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3422c550dfbb616d$var$load("7I4uK"),
    $3422c550dfbb616d$var$load("hUbK8"),
    $3422c550dfbb616d$var$load("b6eef"),
    $3422c550dfbb616d$var$load("1Gr4q"),
    $3422c550dfbb616d$var$load("f7eY1"),
    $3422c550dfbb616d$var$load("kedWY"),
    $3422c550dfbb616d$var$load("9cVML"),
    $3422c550dfbb616d$var$load("7G12e"),
    $3422c550dfbb616d$var$load("4938u"),
    $3422c550dfbb616d$var$load("7SteV"),
    $3422c550dfbb616d$var$load("iYvvi"),
    $3422c550dfbb616d$var$load("eWXZF"),
    $3422c550dfbb616d$var$load("ennNB"),
    $3422c550dfbb616d$var$load("9Hr92"),
    $3422c550dfbb616d$var$load("khIi2"),
    $3422c550dfbb616d$var$load("eEjUf"),
    $3422c550dfbb616d$var$load("kMVpD"),
    $3422c550dfbb616d$var$load("7oAXW"),
    $3422c550dfbb616d$var$load("kHXvF"),
    $3422c550dfbb616d$var$load("ea3NB"),
    $3422c550dfbb616d$var$load("cGkFm"),
    $3422c550dfbb616d$var$load("2jERw"),
    $3422c550dfbb616d$var$load("b7144"),
    $3422c550dfbb616d$var$load("cvcNg"),
    $3422c550dfbb616d$var$load("iZR3N"),
    $3422c550dfbb616d$var$load("jXM1T"),
    $3422c550dfbb616d$var$load("6wr18"),
    $3422c550dfbb616d$var$load("4N1MY"),
    $3422c550dfbb616d$var$load("3LYaV"),
    $3422c550dfbb616d$var$load("ffEVr"),
    $3422c550dfbb616d$var$load("jNr09"),
    $3422c550dfbb616d$var$load("9xmQ5"),
    $3422c550dfbb616d$var$load("20wSi"),
    $3422c550dfbb616d$var$load("9LDVS"),
    $3422c550dfbb616d$var$load("kiMHu"),
    $3422c550dfbb616d$var$load("7J1PC"),
    $3422c550dfbb616d$var$load("446Ip"),
    $3422c550dfbb616d$var$load("a8R25"),
    $3422c550dfbb616d$var$load("g7Yjk"),
    $3422c550dfbb616d$var$load("h4Nf7"),
    $3422c550dfbb616d$var$load("9TOep"),
    $3422c550dfbb616d$var$load("bSSct"),
    $3422c550dfbb616d$var$load("45r7q"),
    $3422c550dfbb616d$var$load("hhss7"),
    $3422c550dfbb616d$var$load("aAWLw"),
    $3422c550dfbb616d$var$load("7EorR"),
    $3422c550dfbb616d$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("fObhU", function(module, exports) {

let $b82448109eb78e73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b82448109eb78e73$var$load("7I4uK"),
    $b82448109eb78e73$var$load("hUbK8"),
    $b82448109eb78e73$var$load("b6eef"),
    $b82448109eb78e73$var$load("1Gr4q"),
    $b82448109eb78e73$var$load("f7eY1"),
    $b82448109eb78e73$var$load("kedWY"),
    $b82448109eb78e73$var$load("9cVML"),
    $b82448109eb78e73$var$load("7G12e"),
    $b82448109eb78e73$var$load("4938u"),
    $b82448109eb78e73$var$load("7SteV"),
    $b82448109eb78e73$var$load("iYvvi"),
    $b82448109eb78e73$var$load("eWXZF"),
    $b82448109eb78e73$var$load("ennNB"),
    $b82448109eb78e73$var$load("9Hr92"),
    $b82448109eb78e73$var$load("khIi2"),
    $b82448109eb78e73$var$load("eEjUf"),
    $b82448109eb78e73$var$load("kMVpD"),
    $b82448109eb78e73$var$load("7oAXW"),
    $b82448109eb78e73$var$load("kHXvF"),
    $b82448109eb78e73$var$load("ea3NB"),
    $b82448109eb78e73$var$load("cGkFm"),
    $b82448109eb78e73$var$load("2jERw"),
    $b82448109eb78e73$var$load("b7144"),
    $b82448109eb78e73$var$load("cvcNg"),
    $b82448109eb78e73$var$load("iZR3N"),
    $b82448109eb78e73$var$load("jXM1T"),
    $b82448109eb78e73$var$load("6wr18"),
    $b82448109eb78e73$var$load("4N1MY"),
    $b82448109eb78e73$var$load("3LYaV"),
    $b82448109eb78e73$var$load("ffEVr"),
    $b82448109eb78e73$var$load("jNr09"),
    $b82448109eb78e73$var$load("9xmQ5"),
    $b82448109eb78e73$var$load("20wSi"),
    $b82448109eb78e73$var$load("9LDVS"),
    $b82448109eb78e73$var$load("kiMHu"),
    $b82448109eb78e73$var$load("7J1PC"),
    $b82448109eb78e73$var$load("446Ip"),
    $b82448109eb78e73$var$load("a8R25"),
    $b82448109eb78e73$var$load("g7Yjk"),
    $b82448109eb78e73$var$load("h4Nf7"),
    $b82448109eb78e73$var$load("9TOep"),
    $b82448109eb78e73$var$load("bSSct"),
    $b82448109eb78e73$var$load("45r7q"),
    $b82448109eb78e73$var$load("hhss7"),
    $b82448109eb78e73$var$load("aAWLw"),
    $b82448109eb78e73$var$load("7EorR"),
    $b82448109eb78e73$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("f9qit", function(module, exports) {

let $b07c1848da30b7af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b07c1848da30b7af$var$load("7I4uK"),
    $b07c1848da30b7af$var$load("hUbK8"),
    $b07c1848da30b7af$var$load("b6eef"),
    $b07c1848da30b7af$var$load("1Gr4q"),
    $b07c1848da30b7af$var$load("f7eY1"),
    $b07c1848da30b7af$var$load("kedWY"),
    $b07c1848da30b7af$var$load("9cVML"),
    $b07c1848da30b7af$var$load("7G12e"),
    $b07c1848da30b7af$var$load("4938u"),
    $b07c1848da30b7af$var$load("7SteV"),
    $b07c1848da30b7af$var$load("iYvvi"),
    $b07c1848da30b7af$var$load("eWXZF"),
    $b07c1848da30b7af$var$load("ennNB"),
    $b07c1848da30b7af$var$load("9Hr92"),
    $b07c1848da30b7af$var$load("khIi2"),
    $b07c1848da30b7af$var$load("eEjUf"),
    $b07c1848da30b7af$var$load("kMVpD"),
    $b07c1848da30b7af$var$load("7oAXW"),
    $b07c1848da30b7af$var$load("kHXvF"),
    $b07c1848da30b7af$var$load("ea3NB"),
    $b07c1848da30b7af$var$load("cGkFm"),
    $b07c1848da30b7af$var$load("2jERw"),
    $b07c1848da30b7af$var$load("b7144"),
    $b07c1848da30b7af$var$load("cvcNg"),
    $b07c1848da30b7af$var$load("iZR3N"),
    $b07c1848da30b7af$var$load("jXM1T"),
    $b07c1848da30b7af$var$load("6wr18"),
    $b07c1848da30b7af$var$load("4N1MY"),
    $b07c1848da30b7af$var$load("3LYaV"),
    $b07c1848da30b7af$var$load("ffEVr"),
    $b07c1848da30b7af$var$load("jNr09"),
    $b07c1848da30b7af$var$load("9xmQ5"),
    $b07c1848da30b7af$var$load("20wSi"),
    $b07c1848da30b7af$var$load("9LDVS"),
    $b07c1848da30b7af$var$load("kiMHu"),
    $b07c1848da30b7af$var$load("7J1PC"),
    $b07c1848da30b7af$var$load("446Ip"),
    $b07c1848da30b7af$var$load("a8R25"),
    $b07c1848da30b7af$var$load("g7Yjk"),
    $b07c1848da30b7af$var$load("h4Nf7"),
    $b07c1848da30b7af$var$load("9TOep"),
    $b07c1848da30b7af$var$load("bSSct"),
    $b07c1848da30b7af$var$load("45r7q"),
    $b07c1848da30b7af$var$load("hhss7"),
    $b07c1848da30b7af$var$load("aAWLw"),
    $b07c1848da30b7af$var$load("7EorR"),
    $b07c1848da30b7af$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("dFwI0", function(module, exports) {

let $9f3879f4fd518797$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9f3879f4fd518797$var$load("7I4uK"),
    $9f3879f4fd518797$var$load("hUbK8"),
    $9f3879f4fd518797$var$load("b6eef"),
    $9f3879f4fd518797$var$load("1Gr4q"),
    $9f3879f4fd518797$var$load("f7eY1"),
    $9f3879f4fd518797$var$load("kedWY"),
    $9f3879f4fd518797$var$load("9cVML"),
    $9f3879f4fd518797$var$load("7G12e"),
    $9f3879f4fd518797$var$load("4938u"),
    $9f3879f4fd518797$var$load("7SteV"),
    $9f3879f4fd518797$var$load("iYvvi"),
    $9f3879f4fd518797$var$load("eWXZF"),
    $9f3879f4fd518797$var$load("ennNB"),
    $9f3879f4fd518797$var$load("9Hr92"),
    $9f3879f4fd518797$var$load("khIi2"),
    $9f3879f4fd518797$var$load("eEjUf"),
    $9f3879f4fd518797$var$load("kMVpD"),
    $9f3879f4fd518797$var$load("7oAXW"),
    $9f3879f4fd518797$var$load("kHXvF"),
    $9f3879f4fd518797$var$load("ea3NB"),
    $9f3879f4fd518797$var$load("cGkFm"),
    $9f3879f4fd518797$var$load("2jERw"),
    $9f3879f4fd518797$var$load("b7144"),
    $9f3879f4fd518797$var$load("cvcNg"),
    $9f3879f4fd518797$var$load("iZR3N"),
    $9f3879f4fd518797$var$load("jXM1T"),
    $9f3879f4fd518797$var$load("6wr18"),
    $9f3879f4fd518797$var$load("4N1MY"),
    $9f3879f4fd518797$var$load("3LYaV"),
    $9f3879f4fd518797$var$load("ffEVr"),
    $9f3879f4fd518797$var$load("jNr09"),
    $9f3879f4fd518797$var$load("9xmQ5"),
    $9f3879f4fd518797$var$load("20wSi"),
    $9f3879f4fd518797$var$load("9LDVS"),
    $9f3879f4fd518797$var$load("kiMHu"),
    $9f3879f4fd518797$var$load("7J1PC"),
    $9f3879f4fd518797$var$load("446Ip"),
    $9f3879f4fd518797$var$load("g7Yjk"),
    $9f3879f4fd518797$var$load("h4Nf7"),
    $9f3879f4fd518797$var$load("9TOep"),
    $9f3879f4fd518797$var$load("bSSct"),
    $9f3879f4fd518797$var$load("45r7q"),
    $9f3879f4fd518797$var$load("hhss7"),
    $9f3879f4fd518797$var$load("a8R25"),
    $9f3879f4fd518797$var$load("lnKog"),
    $9f3879f4fd518797$var$load("aAWLw"),
    $9f3879f4fd518797$var$load("7EorR"),
    $9f3879f4fd518797$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("dwPbT", function(module, exports) {

let $9d95f8f5484f3b69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d95f8f5484f3b69$var$load("7I4uK"),
    $9d95f8f5484f3b69$var$load("hUbK8"),
    $9d95f8f5484f3b69$var$load("30b92"),
    $9d95f8f5484f3b69$var$load("b6eef"),
    $9d95f8f5484f3b69$var$load("1Gr4q"),
    $9d95f8f5484f3b69$var$load("f7eY1"),
    $9d95f8f5484f3b69$var$load("kedWY"),
    $9d95f8f5484f3b69$var$load("9cVML"),
    $9d95f8f5484f3b69$var$load("7G12e"),
    $9d95f8f5484f3b69$var$load("4938u"),
    $9d95f8f5484f3b69$var$load("giX30"),
    $9d95f8f5484f3b69$var$load("lUYNi"),
    $9d95f8f5484f3b69$var$load("7SteV"),
    $9d95f8f5484f3b69$var$load("iYvvi"),
    $9d95f8f5484f3b69$var$load("eWXZF"),
    $9d95f8f5484f3b69$var$load("ennNB"),
    $9d95f8f5484f3b69$var$load("9Hr92"),
    $9d95f8f5484f3b69$var$load("khIi2"),
    $9d95f8f5484f3b69$var$load("eEjUf"),
    $9d95f8f5484f3b69$var$load("kMVpD"),
    $9d95f8f5484f3b69$var$load("7oAXW"),
    $9d95f8f5484f3b69$var$load("le1z7"),
    $9d95f8f5484f3b69$var$load("4xsdA"),
    $9d95f8f5484f3b69$var$load("kHXvF"),
    $9d95f8f5484f3b69$var$load("ea3NB"),
    $9d95f8f5484f3b69$var$load("59hV4"),
    $9d95f8f5484f3b69$var$load("cGkFm"),
    $9d95f8f5484f3b69$var$load("2jERw"),
    $9d95f8f5484f3b69$var$load("b7144"),
    $9d95f8f5484f3b69$var$load("fuOfV"),
    $9d95f8f5484f3b69$var$load("jL1Ke"),
    $9d95f8f5484f3b69$var$load("5MQ0D"),
    $9d95f8f5484f3b69$var$load("cvcNg"),
    $9d95f8f5484f3b69$var$load("iZR3N"),
    $9d95f8f5484f3b69$var$load("jXM1T"),
    $9d95f8f5484f3b69$var$load("6wr18"),
    $9d95f8f5484f3b69$var$load("4N1MY"),
    $9d95f8f5484f3b69$var$load("3LYaV"),
    $9d95f8f5484f3b69$var$load("ffEVr"),
    $9d95f8f5484f3b69$var$load("jNr09"),
    $9d95f8f5484f3b69$var$load("9xmQ5"),
    $9d95f8f5484f3b69$var$load("20wSi"),
    $9d95f8f5484f3b69$var$load("9LDVS"),
    $9d95f8f5484f3b69$var$load("kiMHu"),
    $9d95f8f5484f3b69$var$load("7J1PC"),
    $9d95f8f5484f3b69$var$load("446Ip"),
    $9d95f8f5484f3b69$var$load("fwbNS"),
    $9d95f8f5484f3b69$var$load("g7Yjk"),
    $9d95f8f5484f3b69$var$load("h4Nf7"),
    $9d95f8f5484f3b69$var$load("9TOep"),
    $9d95f8f5484f3b69$var$load("bSSct"),
    $9d95f8f5484f3b69$var$load("45r7q"),
    $9d95f8f5484f3b69$var$load("hhss7"),
    $9d95f8f5484f3b69$var$load("a8R25"),
    $9d95f8f5484f3b69$var$load("lnKog"),
    $9d95f8f5484f3b69$var$load("aAWLw"),
    $9d95f8f5484f3b69$var$load("7EorR"),
    $9d95f8f5484f3b69$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("lKE59", function(module, exports) {

let $fd5cfc52e6fdb54f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd5cfc52e6fdb54f$var$load("7I4uK"),
    $fd5cfc52e6fdb54f$var$load("hUbK8"),
    $fd5cfc52e6fdb54f$var$load("30b92"),
    $fd5cfc52e6fdb54f$var$load("b6eef"),
    $fd5cfc52e6fdb54f$var$load("1Gr4q"),
    $fd5cfc52e6fdb54f$var$load("f7eY1"),
    $fd5cfc52e6fdb54f$var$load("kedWY"),
    $fd5cfc52e6fdb54f$var$load("9cVML"),
    $fd5cfc52e6fdb54f$var$load("7G12e"),
    $fd5cfc52e6fdb54f$var$load("4938u"),
    $fd5cfc52e6fdb54f$var$load("giX30"),
    $fd5cfc52e6fdb54f$var$load("lUYNi"),
    $fd5cfc52e6fdb54f$var$load("7SteV"),
    $fd5cfc52e6fdb54f$var$load("iYvvi"),
    $fd5cfc52e6fdb54f$var$load("eWXZF"),
    $fd5cfc52e6fdb54f$var$load("ennNB"),
    $fd5cfc52e6fdb54f$var$load("9Hr92"),
    $fd5cfc52e6fdb54f$var$load("khIi2"),
    $fd5cfc52e6fdb54f$var$load("eEjUf"),
    $fd5cfc52e6fdb54f$var$load("kMVpD"),
    $fd5cfc52e6fdb54f$var$load("7oAXW"),
    $fd5cfc52e6fdb54f$var$load("le1z7"),
    $fd5cfc52e6fdb54f$var$load("4xsdA"),
    $fd5cfc52e6fdb54f$var$load("kHXvF"),
    $fd5cfc52e6fdb54f$var$load("ea3NB"),
    $fd5cfc52e6fdb54f$var$load("59hV4"),
    $fd5cfc52e6fdb54f$var$load("cGkFm"),
    $fd5cfc52e6fdb54f$var$load("2jERw"),
    $fd5cfc52e6fdb54f$var$load("b7144"),
    $fd5cfc52e6fdb54f$var$load("fuOfV"),
    $fd5cfc52e6fdb54f$var$load("jL1Ke"),
    $fd5cfc52e6fdb54f$var$load("5MQ0D"),
    $fd5cfc52e6fdb54f$var$load("cvcNg"),
    $fd5cfc52e6fdb54f$var$load("iZR3N"),
    $fd5cfc52e6fdb54f$var$load("jXM1T"),
    $fd5cfc52e6fdb54f$var$load("6wr18"),
    $fd5cfc52e6fdb54f$var$load("4N1MY"),
    $fd5cfc52e6fdb54f$var$load("3LYaV"),
    $fd5cfc52e6fdb54f$var$load("ffEVr"),
    $fd5cfc52e6fdb54f$var$load("jNr09"),
    $fd5cfc52e6fdb54f$var$load("9xmQ5"),
    $fd5cfc52e6fdb54f$var$load("20wSi"),
    $fd5cfc52e6fdb54f$var$load("9LDVS"),
    $fd5cfc52e6fdb54f$var$load("kiMHu"),
    $fd5cfc52e6fdb54f$var$load("7J1PC"),
    $fd5cfc52e6fdb54f$var$load("446Ip"),
    $fd5cfc52e6fdb54f$var$load("fwbNS"),
    $fd5cfc52e6fdb54f$var$load("g7Yjk"),
    $fd5cfc52e6fdb54f$var$load("h4Nf7"),
    $fd5cfc52e6fdb54f$var$load("9TOep"),
    $fd5cfc52e6fdb54f$var$load("bSSct"),
    $fd5cfc52e6fdb54f$var$load("45r7q"),
    $fd5cfc52e6fdb54f$var$load("hhss7"),
    $fd5cfc52e6fdb54f$var$load("a8R25"),
    $fd5cfc52e6fdb54f$var$load("lnKog"),
    $fd5cfc52e6fdb54f$var$load("aAWLw"),
    $fd5cfc52e6fdb54f$var$load("7EorR"),
    $fd5cfc52e6fdb54f$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fArXz", function(module, exports) {

let $b58fe807a3db6ad5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b58fe807a3db6ad5$var$load("7I4uK"),
    $b58fe807a3db6ad5$var$load("hUbK8"),
    $b58fe807a3db6ad5$var$load("b6eef"),
    $b58fe807a3db6ad5$var$load("1Gr4q"),
    $b58fe807a3db6ad5$var$load("f7eY1"),
    $b58fe807a3db6ad5$var$load("kedWY"),
    $b58fe807a3db6ad5$var$load("9cVML"),
    $b58fe807a3db6ad5$var$load("7G12e"),
    $b58fe807a3db6ad5$var$load("4938u"),
    $b58fe807a3db6ad5$var$load("7SteV"),
    $b58fe807a3db6ad5$var$load("iYvvi"),
    $b58fe807a3db6ad5$var$load("eWXZF"),
    $b58fe807a3db6ad5$var$load("ennNB"),
    $b58fe807a3db6ad5$var$load("9Hr92"),
    $b58fe807a3db6ad5$var$load("khIi2"),
    $b58fe807a3db6ad5$var$load("eEjUf"),
    $b58fe807a3db6ad5$var$load("kMVpD"),
    $b58fe807a3db6ad5$var$load("7oAXW"),
    $b58fe807a3db6ad5$var$load("kHXvF"),
    $b58fe807a3db6ad5$var$load("ea3NB"),
    $b58fe807a3db6ad5$var$load("cGkFm"),
    $b58fe807a3db6ad5$var$load("2jERw"),
    $b58fe807a3db6ad5$var$load("b7144"),
    $b58fe807a3db6ad5$var$load("cvcNg"),
    $b58fe807a3db6ad5$var$load("iZR3N"),
    $b58fe807a3db6ad5$var$load("jXM1T"),
    $b58fe807a3db6ad5$var$load("6wr18"),
    $b58fe807a3db6ad5$var$load("4N1MY"),
    $b58fe807a3db6ad5$var$load("3LYaV"),
    $b58fe807a3db6ad5$var$load("ffEVr"),
    $b58fe807a3db6ad5$var$load("jNr09"),
    $b58fe807a3db6ad5$var$load("9xmQ5"),
    $b58fe807a3db6ad5$var$load("20wSi"),
    $b58fe807a3db6ad5$var$load("9LDVS"),
    $b58fe807a3db6ad5$var$load("kiMHu"),
    $b58fe807a3db6ad5$var$load("7J1PC"),
    $b58fe807a3db6ad5$var$load("446Ip"),
    $b58fe807a3db6ad5$var$load("a8R25"),
    $b58fe807a3db6ad5$var$load("g7Yjk"),
    $b58fe807a3db6ad5$var$load("h4Nf7"),
    $b58fe807a3db6ad5$var$load("9TOep"),
    $b58fe807a3db6ad5$var$load("bSSct"),
    $b58fe807a3db6ad5$var$load("45r7q"),
    $b58fe807a3db6ad5$var$load("hhss7"),
    $b58fe807a3db6ad5$var$load("aAWLw"),
    $b58fe807a3db6ad5$var$load("7EorR"),
    $b58fe807a3db6ad5$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("dMpk7", function(module, exports) {

let $a08366ca363b45ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a08366ca363b45ed$var$load("7I4uK"),
    $a08366ca363b45ed$var$load("hUbK8"),
    $a08366ca363b45ed$var$load("b6eef"),
    $a08366ca363b45ed$var$load("1Gr4q"),
    $a08366ca363b45ed$var$load("f7eY1"),
    $a08366ca363b45ed$var$load("kedWY"),
    $a08366ca363b45ed$var$load("9cVML"),
    $a08366ca363b45ed$var$load("7G12e"),
    $a08366ca363b45ed$var$load("4938u"),
    $a08366ca363b45ed$var$load("7SteV"),
    $a08366ca363b45ed$var$load("iYvvi"),
    $a08366ca363b45ed$var$load("eWXZF"),
    $a08366ca363b45ed$var$load("ennNB"),
    $a08366ca363b45ed$var$load("9Hr92"),
    $a08366ca363b45ed$var$load("khIi2"),
    $a08366ca363b45ed$var$load("eEjUf"),
    $a08366ca363b45ed$var$load("kMVpD"),
    $a08366ca363b45ed$var$load("7oAXW"),
    $a08366ca363b45ed$var$load("kHXvF"),
    $a08366ca363b45ed$var$load("ea3NB"),
    $a08366ca363b45ed$var$load("cGkFm"),
    $a08366ca363b45ed$var$load("2jERw"),
    $a08366ca363b45ed$var$load("b7144"),
    $a08366ca363b45ed$var$load("cvcNg"),
    $a08366ca363b45ed$var$load("iZR3N"),
    $a08366ca363b45ed$var$load("jXM1T"),
    $a08366ca363b45ed$var$load("6wr18"),
    $a08366ca363b45ed$var$load("4N1MY"),
    $a08366ca363b45ed$var$load("3LYaV"),
    $a08366ca363b45ed$var$load("ffEVr"),
    $a08366ca363b45ed$var$load("jNr09"),
    $a08366ca363b45ed$var$load("9xmQ5"),
    $a08366ca363b45ed$var$load("20wSi"),
    $a08366ca363b45ed$var$load("9LDVS"),
    $a08366ca363b45ed$var$load("kiMHu"),
    $a08366ca363b45ed$var$load("7J1PC"),
    $a08366ca363b45ed$var$load("446Ip"),
    $a08366ca363b45ed$var$load("g7Yjk"),
    $a08366ca363b45ed$var$load("h4Nf7"),
    $a08366ca363b45ed$var$load("9TOep"),
    $a08366ca363b45ed$var$load("bSSct"),
    $a08366ca363b45ed$var$load("45r7q"),
    $a08366ca363b45ed$var$load("hhss7"),
    $a08366ca363b45ed$var$load("a8R25"),
    $a08366ca363b45ed$var$load("lnKog"),
    $a08366ca363b45ed$var$load("aAWLw"),
    $a08366ca363b45ed$var$load("7EorR"),
    $a08366ca363b45ed$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("aMx68", function(module, exports) {

let $7d980fa2e2193a43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7d980fa2e2193a43$var$load("7I4uK"),
    $7d980fa2e2193a43$var$load("hUbK8"),
    $7d980fa2e2193a43$var$load("b6eef"),
    $7d980fa2e2193a43$var$load("1Gr4q"),
    $7d980fa2e2193a43$var$load("f7eY1"),
    $7d980fa2e2193a43$var$load("kedWY"),
    $7d980fa2e2193a43$var$load("9cVML"),
    $7d980fa2e2193a43$var$load("7G12e"),
    $7d980fa2e2193a43$var$load("4938u"),
    $7d980fa2e2193a43$var$load("7SteV"),
    $7d980fa2e2193a43$var$load("iYvvi"),
    $7d980fa2e2193a43$var$load("eWXZF"),
    $7d980fa2e2193a43$var$load("ennNB"),
    $7d980fa2e2193a43$var$load("9Hr92"),
    $7d980fa2e2193a43$var$load("khIi2"),
    $7d980fa2e2193a43$var$load("eEjUf"),
    $7d980fa2e2193a43$var$load("kMVpD"),
    $7d980fa2e2193a43$var$load("7oAXW"),
    $7d980fa2e2193a43$var$load("kHXvF"),
    $7d980fa2e2193a43$var$load("ea3NB"),
    $7d980fa2e2193a43$var$load("cGkFm"),
    $7d980fa2e2193a43$var$load("2jERw"),
    $7d980fa2e2193a43$var$load("b7144"),
    $7d980fa2e2193a43$var$load("cvcNg"),
    $7d980fa2e2193a43$var$load("iZR3N"),
    $7d980fa2e2193a43$var$load("jXM1T"),
    $7d980fa2e2193a43$var$load("6wr18"),
    $7d980fa2e2193a43$var$load("4N1MY"),
    $7d980fa2e2193a43$var$load("3LYaV"),
    $7d980fa2e2193a43$var$load("ffEVr"),
    $7d980fa2e2193a43$var$load("jNr09"),
    $7d980fa2e2193a43$var$load("9xmQ5"),
    $7d980fa2e2193a43$var$load("20wSi"),
    $7d980fa2e2193a43$var$load("9LDVS"),
    $7d980fa2e2193a43$var$load("kiMHu"),
    $7d980fa2e2193a43$var$load("7J1PC"),
    $7d980fa2e2193a43$var$load("446Ip"),
    $7d980fa2e2193a43$var$load("g7Yjk"),
    $7d980fa2e2193a43$var$load("h4Nf7"),
    $7d980fa2e2193a43$var$load("9TOep"),
    $7d980fa2e2193a43$var$load("bSSct"),
    $7d980fa2e2193a43$var$load("45r7q"),
    $7d980fa2e2193a43$var$load("hhss7"),
    $7d980fa2e2193a43$var$load("a8R25"),
    $7d980fa2e2193a43$var$load("lnKog"),
    $7d980fa2e2193a43$var$load("aAWLw"),
    $7d980fa2e2193a43$var$load("7EorR"),
    $7d980fa2e2193a43$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kntSv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kntSv", function(module, exports) {

let $ed5d21cd821df813$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ed5d21cd821df813$var$load("a8R25"),
    $ed5d21cd821df813$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.aaab9cfb.js.map
